module.exports = __webpack_public_path__ + "static/media/CoffeshopEnviro.8ba119cf.jpg";